<template>
    <div style="background-color: white">
        <v-container v-if="booking" fluid>
            <v-row class="pa-5">
                <v-col cols="12" sm="12">
                    <v-img :src="require('../assets/RepairSmart_White.png')" width="200" />
                    <h3 class="subheading secondary--text">Express Car Body Repairs</h3>
                    <h3 class="subheading secondary--text">01903 782888</h3>
                    <div style="float: right" v-if="booking.dailyTotals[booking.day -1]">
                        <span class="ml-3"  v-if="booking.dailyTotals[booking.day -1].isPdr" style="color: yellow;"><strong>PDR</strong></span>
                        <span class="ml-3"  v-if="booking.dailyTotals[booking.day -1].isAlloys" style="color: orange;"><strong>Alloys <span v-if="booking.alloyTypes">- {{booking.alloyTypes}}</span></strong></span>
                        <span class="ml-3"  v-if="booking.dailyTotals[booking.day -1].isCCar" style="color: green;"><strong>Courtesy Car - <span v-if="booking.ccTypeManual">M</span><span v-else>A</span></strong></span>
                        <span class="ml-3"  v-if="booking.dailyTotals[booking.day -1].isDropOff" style="color: #996699;"><strong>Drop Off</strong></span>
                        <span class="ml-3"  v-if="booking.dailyTotals[booking.day -1].isPickUp" style="color: #333399;"><strong>Pick Up</strong></span>
                    </div>
                </v-col>
                <v-col cols="12" sm="12" class="pa-3">
                    <div class="pa-3" style="border: 1px solid black; border-radius: 5px" v-if="booking">
                        <v-row>
                            <v-col cols="12" sm="12" md="4" class="pa-2">
                                <h4 class="title secondary--text">REPAIR booking FOR <span class="primary--text"><strong>{{booking.customer.name}}</strong></span></h4>
                                <h5 class="title">Created By: <strong>{{booking.bookingMadeBy}}</strong></h5>
                            </v-col>
                            <v-col cols="12" sm="12" md="4" class="pa-2">
                                <h5 class="title">Make: <strong>{{booking.customer.make}}</strong></h5>
                                <h5 class="title">Colour: <strong>{{booking.customer.colour}}</strong></h5>
                            </v-col>
                            <v-col cols="12" sm="12" md="4" class="pa-2">
                                <h5 class="title">Phone: <strong>{{booking.customer.mobile}} <span v-if="booking.customer.phone">, {{booking.customer.phone}}</span></strong></h5>
                                <h5 class="title">Registration: <span v-if="booking.customer.vrm" style="width: 100px" class="text-xs-center"><span
                                        class="vrm">{{ booking.customer.vrm }}</span></span></h5>
                            </v-col>
                            <v-col cols="12" sm="12" class="hidden-sm-and-down">
                                <canvas v-if="canvasId" width="1000" height="520" :id="canvasId" class="canvas hidden-sm-and-down" />
                                <h5 class="title">Areas marked agreed to be repaired</h5>
                                <v-spacer />
                                <h5 class="title">Repair will take {{booking.numberofDays ? booking.numberofDays : booking.days}} days</h5>
                            </v-col>
                            <v-col cols="12" sm="12" class="hidden-md-and-up hide">
                                <v-flex xs12>
                                    <h5 class="subheading">Open on a desktop to view areas to be repaired</h5>
                                    <h5 v-if="booking.numberofDays || booking.days" class="subheading">Repair will take {{booking.numberofDays ? booking.numberofDays : booking.days}} days</h5>
                                </v-flex>
                            </v-col>
                        </v-row>
                    </div>
                </v-col>
                <v-col cols="12" sm="12">
                    <div style="border: 1px solid black; border-radius: 5px" class="pa-2 mt-5">
                        <h5 class="title"><strong>Repairs</strong></h5>
                        <v-list-item v-for="(repair, index) in booking.damage" :key="index">
                            <v-list-item-content>
                                <v-list-item-title>
                                    <span v-if="repair.repairDetail">{{repair.repairDetail}}</span>
                                    <span v-if="!repair.repairDetail">{{repair.repair}}</span>
                                    -<span v-if="repair.scratch"> Scratch, </span>
                                    <span v-if="repair.scratchDent"> Scratch & Dent <span v-if="repair.damageCommentsScratchDent">- {{repair.damageCommentsScratchDent}}</span>, </span>
                                    <span v-if="repair.scratch"> Scratch <span v-if="repair.damageCommentsScratch">- {{repair.damageCommentsScratch}}</span>, </span>
                                    <span v-if="repair.blend"> Blend Colour <span v-if="repair.damageCommentsBlend">- {{repair.damageCommentsBlend}}</span>, </span>
                                    <span v-if="repair.chips"> Chips <span v-if="repair.damageCommentsChips">- {{repair.damageCommentsChips}}</span>, </span>
                                    <span v-if="repair.dent"> Dent <span v-if="repair.damageCommentsDent">- {{repair.damageCommentsDent}}</span>, </span>
                                    <span v-if="repair.trim"> Trim <span v-if="repair.damageCommentsTrim">- {{repair.damageCommentsTrim}}</span>, </span>
                                    <span v-if="repair.osr"> Offside Rear, </span>
                                    <span v-if="repair.nsr"> Nearside Rear, </span>
                                    <span v-if="repair.osf"> Offside Front, </span>
                                    <span v-if="repair.nsf"> Nearside Front, </span>
                                </v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action>
                                <strong class="text-right">£{{ repair.labour | amount }}</strong>
                            </v-list-item-action>
                        </v-list-item>

                        <div v-if="booking.parts && booking.parts.length > 0">
                            <v-divider />
                            <h5 class="title"><strong>Parts</strong></h5>
                            <v-list-item v-for="(part, index) in booking.parts" :key="index">
                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{part.name}}
                                    </v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <strong class="text-right">£{{part.price.toFixed(2)}}</strong>
                                </v-list-item-action>
                            </v-list-item>
                        </div>
                        <div class="text-right">
                            <h5 class="title">Subtotal: £{{parseFloat(booking.total).toFixed(2)}}</h5>
                          <h5 v-if="booking.discountValue && booking.discountValue > 0" class="title">Discount - {{booking.discountNotes}}: £-{{parseFloat(booking.discountValue).toFixed(2)}}</h5>
                            <h5 class="title">VAT: £{{parseFloat((booking.total - booking.discountValue) * 0.20).toFixed(2)}}</h5>
                            <h5 class="title">Total: £{{parseFloat((booking.total - booking.discountValue) + (booking.total - booking.discountValue) * 0.20).toFixed(2)}}</h5>
                        </div>
                        <p class="text-center subheading mt-3"><strong>Payments accepted: All credit and debit cards or cash. We do not accept cheques
                            or American express</strong></p>
                        <div class="mt-4">
                            <v-row v-if="booking.notes" class="pa-2">
                                <v-col>
                                    <h5 class="title">Comments</h5>
                                    <p class="body-1" v-for="(note, index) in notes" :key="index">{{note}}</p>
                                    <div v-if="booking.discountValue > 0">
                                        <h5 class="subheading">Discount</h5>
                                        <p><strong>{{booking.discountValue && booking.discountNotes}}</strong></p>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                </v-col>
                <v-col cols="12" sm="12">
                    <v-row class="text-center mt-5">
                        <v-col>
                            <h4 class="subheading secondary--text">LIFETIME GUARANTEE</h4>
                        </v-col>
                        <v-col>
                            <h4 class="subheading secondary--text">COURTESY CARS</h4>
                        </v-col>
                        <v-col>
                            <h4 class="subheading secondary--text">EXPRESS SERVICE</h4>
                        </v-col>
                    </v-row>
                    <v-row class="text-center mt-3">
                        <p class="body-1">Damage repaired in marked areas only. Any other damage on the panel will not be repaired
                            unless otherwise discussed and marked. Paint is mixed to paint manufacturers’’
                            specifications and as such can be subject to slight variation to the original colour. At
                            Repair Smart we go to every effort to ensure the closest possible colour match, but (like
                            all other repair companies) cannot guarantee an exact match.Our guarantee cannot be upheld
                            if we are repairing over a previous repair/refinish (i.e. not manufacturers finish). If
                            there is any corrosion / oxidation present i.e. rust we can not guarantee these repairs
                            unless panels are replaced. We work to very high standards but we are producing a ‘refinish’
                            which cannot be compared to a factory finish produced by automated machinery and in
                            unrealistic environments.</p>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    export default {
        name: "DailyBooking",
        async mounted() {
            this.canvasId = this.booking._id;
            const tempNotes = [];
            if (this.booking.notes) {
                this.notes = this.booking.notes.split('\n');
            }
            this.notes.forEach((note) => {
                if (note !== '') {
                    tempNotes.push(note);
                }
            });
            this.notes = tempNotes;
            setTimeout(() => {
                this.c = document.getElementById(this.canvasId);
                this.ctx = this.c.getContext('2d');
                this.ctx.clearRect(0,0,800,800);
                this.loadState();
            }, 500);
        },
        props: {
            booking: Object
        },
        methods: {
            loadState() {
                if (this.booking.image) {
                    const data = JSON.parse(this.booking.image);
                    const image = new Image();
                    const c = document.getElementById(this.canvasId);
                    const ctx = this.c.getContext("2d");
                    image.onload = function () {
                        ctx.clearRect(0, 0, c.width, c.height);
                        ctx.drawImage(image, 0, 0); // draw the new image to the screen
                    };
                    image.src = data.image;
                }
            }
        },
        data() {
            return {
                overlay: false,
                canvasId: null,
                c: null,
                ctx: null,
                notes: []
            }
        }
    }
</script>

<style scoped>
    .canvas {
        background: url('../assets/car-outline.png') !important;
    }

    @media print {
        .hide { display: none}
    }
</style>
